import React from "react"

import Style from "./style"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const AlertModal = () => {
    const [label, , resetState] = useAlertModalAtom()

    return (
        <DefaultModal closeEvent={resetState} upper>
            <Style.Label>{label}</ Style.Label>
            <DefaultButton small clickEvent={resetState}>확인</DefaultButton>
        </DefaultModal>
    )
}

export default AlertModal